import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/logo.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: '#221f20',
    className: null,
};

const Logo = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlnsa="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
        x="0px"
        y="0px"
        width="140px"
        height="53.7px"
        viewBox="0 0 140 53.7"
        xmlSpace="preserve"
        className={classNames([styles.container, { [className]: className !== null }])}
    >
        <g>
            <polygon
                fill={color}
                points="6.3,5 11.9,14.8 14.4,14.8 14.4,0.2 12,0.2 12,10 6.4,0.2 3.9,0.2 3.9,14.8 6.3,14.8 	"
            />
            <path
                fill={color}
                d="M23.3,15c2.8,0,5.6-3,5.6-7.5C28.9,3,26.1,0,23.3,0c-2.8,0-5.6,3-5.6,7.5C17.7,12,20.5,15,23.3,15z M23.3,2.4
    		c1.4,0,3,1.9,3,5.1c0,3.2-1.6,5.1-3,5.1s-3-1.9-3-5.1C20.3,4.3,21.9,2.4,23.3,2.4z"
            />
            <path
                fill={color}
                d="M42,10.9V0.2h-2.5v10.5c-0.3,1.1-1.2,1.9-2.4,1.9c-1.2,0-2.2-0.8-2.4-1.9V0.2h-2.5v10.7c0.4,2.3,2.2,4.2,5,4.2
    		C39.8,15,41.6,13.2,42,10.9z"
            />
            <polygon
                fill={color}
                points="51.6,14.8 56,0.2 53.4,0.2 50.3,11.4 47.1,0.2 44.4,0.2 48.9,14.8 	"
            />
            <polygon
                fill={color}
                points="67.1,12.5 61.1,12.5 61.1,8.5 66.2,8.5 66.2,6.2 61.1,6.2 61.1,2.5 66.9,2.5 66.9,0.2 58.6,0.2
    		58.6,14.8 67.1,14.8 	"
            />
            <path
                fill={color}
                d="M72.4,11.3h4.5l1,3.5h2.7L76.1,0.2h-2.8l-4.5,14.6h2.6L72.4,11.3z M74.7,3.4l1.6,5.6h-3.2L74.7,3.4z"
            />
            <path
                fill={color}
                d="M87.9,15c2.8,0,4.5-1.8,4.9-4.2V0.2h-2.5v10.5c-0.3,1.1-1.2,1.9-2.4,1.9c-1.2,0-2.2-0.8-2.4-1.9V0.2h-2.5v10.7
    		C83.3,13.2,85.1,15,87.9,15z"
            />
            <polygon
                fill={color}
                points="2.5,47.3 7.6,47.3 7.6,45.1 2.5,45.1 2.5,41.4 8.3,41.4 8.3,39.1 0,39.1 0,53.7 8.5,53.7 8.5,51.4
    		2.5,51.4 	"
            />
            <polygon
                fill={color}
                points="21.3,39.1 18.4,39.1 15.9,43.9 13.1,39.1 10.2,39.1 14.3,46.3 10,53.7 12.9,53.7 15.6,48.6 18.6,53.7
    		21.5,53.7 17.2,46.2 	"
            />
            <path
                fill={color}
                d="M29.6,39.1h-5.7v14.6h2.5v-5.6h3.2c2.1-0.4,4-2.2,4-4.5C33.6,41.3,31.7,39.5,29.6,39.1z M29.1,45.8h-2.7v-4.4
    		h2.7c1.2,0.3,1.9,1.1,1.9,2.2C31,44.7,30.3,45.6,29.1,45.8z"
            />
            <polygon
                fill={color}
                points="38.6,47.3 43.7,47.3 43.7,45.1 38.6,45.1 38.6,41.4 44.4,41.4 44.4,39.1 36.1,39.1 36.1,53.7
    		44.6,53.7 44.6,51.4 38.6,51.4 	"
            />
            <polygon fill={color} points="40.9,35.5 40.3,38.1 40.8,38.1 43.8,35.5 	" />
            <path
                fill={color}
                d="M57.2,43.4c0-2.2-1.9-4-3.9-4.3h-5.6v14.6h2.5v-6h1.9l2.7,6h2.8l-3-6.4C56.1,46.6,57.2,45.2,57.2,43.4z
    		 M52.8,45.4h-2.7v-4h2.7c1.1,0.2,1.8,1,1.8,2C54.6,44.4,53.9,45.2,52.8,45.4z"
            />
            <rect x="60.4" y="39.1" fill={color} width="2.5" height="14.6" />
            <polygon
                fill={color}
                points="73.4,47.1 69.4,39.1 67.1,39.1 67.1,53.7 69.5,53.7 69.5,44.7 73.3,51.6 77.1,44.7 77.1,53.7
    		79.6,53.7 79.6,39.1 77.3,39.1 	"
            />
            <polygon
                fill={color}
                points="86.3,47.3 91.4,47.3 91.4,45.1 86.3,45.1 86.3,41.4 92.1,41.4 92.1,39.1 83.8,39.1 83.8,53.7
    		92.3,53.7 92.3,51.4 86.3,51.4 	"
            />
            <polygon
                fill={color}
                points="103.4,48.9 97.8,39.1 95.3,39.1 95.3,53.7 97.7,53.7 97.7,43.9 103.3,53.7 105.8,53.7 105.8,39.1
    		103.4,39.1 	"
            />
            <polygon
                fill={color}
                points="118.2,39.1 108.2,39.1 108.2,41.4 111.9,41.4 111.9,53.7 114.4,53.7 114.4,41.4 118.2,41.4 	"
            />
            <path
                fill={color}
                d="M122.4,39.1l-4.5,14.6h2.6l1-3.5h4.5l1,3.5h2.7l-4.5-14.6H122.4z M122.1,48l1.6-5.6l1.6,5.6H122.1z"
            />
            <polygon
                fill={color}
                points="134.3,51.4 134.3,39.1 131.8,39.1 131.8,53.7 140,53.7 140,51.4 	"
            />
            <polygon
                fill={color}
                points="12.6,33.1 15.1,33.2 15.6,20.9 19.3,21 19.4,18.7 9.4,18.3 9.4,20.6 13.1,20.8 	"
            />
            <polygon
                fill={color}
                points="24.3,27.2 29.4,27.4 29.1,33.7 31.7,33.8 32.3,19.2 29.7,19.1 29.5,25 24.4,24.8 24.6,18.9 22.1,18.8
    		21.5,33.4 24.1,33.5 	"
            />
            <polygon fill={color} points="40.9,18.5 41.3,18.6 44.5,16.1 41.6,16 	" />
            <polygon
                fill={color}
                points="36,34 44.6,34.3 44.6,32 38.7,31.7 38.8,27.7 43.9,27.9 44,25.6 38.9,25.4 39.1,21.8 44.8,22
    		44.9,19.7 36.6,19.3 	"
            />
            <path
                fill={color}
                d="M51.3,19.9l-5.1,14.5l2.6,0.1L50,31l4.5,0.2l0.9,3.6l2.7,0.1L54.1,20L51.3,19.9z M50.7,28.8l1.8-5.6l1.4,5.7
    		L50.7,28.8z"
            />
            <polygon
                fill={color}
                points="49.8,18.9 50.4,18.9 52.8,17.8 55.2,19.1 55.7,19.1 53.9,16.5 51.9,16.4 	"
            />
            <polygon
                fill={color}
                points="68.8,20.6 58.8,20.2 58.7,22.6 62.4,22.7 61.9,35 64.4,35.1 64.9,22.8 68.7,23 	"
            />
            <path
                fill={color}
                d="M81,25.4c0.1-2.2-1.8-4.1-3.8-4.5l-5.6-0.2L71,35.4l2.5,0.1l0.2-6l1.9,0.1l2.5,6.1l2.8,0.1l-2.8-6.5
    		C79.7,28.6,80.9,27.2,81,25.4z M76.5,27.3l-2.7-0.1l0.2-4l2.7,0.1c1,0.3,1.7,1,1.7,2.1C78.3,26.3,77.6,27.1,76.5,27.3z"
            />
            <polygon
                fill={color}
                points="84.2,35.9 92.7,36.2 92.8,33.9 86.9,33.6 87,29.6 92.1,29.8 92.2,27.5 87.1,27.3 87.3,23.7 93,23.9
    		93.1,21.6 84.8,21.3 	"
            />
        </g>
    </svg>
);

Logo.propTypes = propTypes;
Logo.defaultProps = defaultProps;

export default Logo;
